import Heading from '../../Typography/Heading/Heading.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import styled from 'styled-components';

const StyledTalentHeading = styled(Heading) `
  margin: 0 0 0.25rem;
`;
const StyledTalentText = styled(TextComponent) `
  margin: 0;
`;
const StyledTalentAnchor = styled.a `
  text-decoration: none;
  transition-property: opacity;
  transition-duration: ${props => props.theme.animation.duration.quick1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};

  @media (pointer: fine) {
    &:hover {
      ${StyledTalentText}, ${StyledTalentHeading} {
        opacity: 0.7;
      }
    }
  }
`;
const StyledTalentsImageContainer = styled.div `
  width: 288px;
  height: 162px;
  margin-bottom: 1rem;
`;

export { StyledTalentAnchor, StyledTalentHeading, StyledTalentText, StyledTalentsImageContainer };
//# sourceMappingURL=TalentCard.styles.mjs.map
